import { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import './firebase';
import SignPage from './unAuth/SignPage';
import HomePage from './unAuth/homePage';
import AuthAction from './unAuth/AuthAction';
import Dashboard from './Auth/Dashboard';
import Reservations from './Auth/guest/Reservations';
import MealsAttended from './Auth/guest/MealsAttended';
import HostDashboard from './Auth/host/HostDashboard';
import MealsHosted from './Auth/host/MealsHosted';
import CreateListing from './Auth/host/createListing';
import EditListing from './Auth/host/editListing';
import MealSummary from './components/mealSummary';
import CreateReview from './components/createReview';
import Profile from './Auth/profile';
import ListingFeed from './Auth/guest/listingFeed';
import About from './unAuth/About';
import InviteFriends from './unAuth/InviteFriends';
import Nav from './components/Nav';
import HostAccessModal from './components/HostAccessModal';
import Reviews from './Auth/reviewHistory';


const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div>Loading...</div>;

  if (!currentUser) {
    localStorage.setItem('returnAfterSignIn', location.pathname);
    return <Navigate to="/signup" />;
  }

  return children;
};

const HostRoute = ({ children }) => {
  const { currentUser, loading, isHost } = useAuth();
  const [accessGranted, setAccessGranted] = useState(false);

  if (loading) return <div>Loading...</div>;

  if (!currentUser) return <Navigate to="/signup" />;

  if (isHost || accessGranted) return children;

  return (
    <HostAccessModal
      isOpen={true}
      onClose={() => window.history.back()}
      onSuccess={() => setAccessGranted(true)}
    />
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Nav />

          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/HomePage" element={<HomePage />} />
              <Route path="/signup" element={<SignPage />} />
              <Route path="/auth-action" element={<AuthAction />} />
              <Route path="/about" element={<About />} />
              <Route path="/invite" element={<InviteFriends />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/reservations" element={<PrivateRoute><Reservations /></PrivateRoute>} />
              <Route path="/meals-attended" element={<PrivateRoute><MealsAttended /></PrivateRoute>} />
              <Route path="/host-dashboard" element={<PrivateRoute><HostDashboard /></PrivateRoute>} />
              <Route path="/meals-hosted" element={<PrivateRoute><MealsHosted /></PrivateRoute>} />
              <Route path="/create-listing" element={<HostRoute><CreateListing /></HostRoute>} />
              <Route path="/meal-summary/:mealId" element={<PrivateRoute><MealSummary /></PrivateRoute>} />
              <Route path="/edit-listing/:mealId" element={<PrivateRoute><EditListing /></PrivateRoute>} />
              <Route path="/create-review/:bookingId" element={<PrivateRoute><CreateReview /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/feed" element={<PrivateRoute><ListingFeed /></PrivateRoute>} />
              <Route path="/reviews" element={<PrivateRoute><Reviews /></PrivateRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
